import RecaptchaWrapper from './recaptcha-enterprise-v2';

export default RecaptchaWrapper;
